const NavLinks = () => {
    return ( 
        <ul className="nav-links">
            <li className="nav-link">how we work</li>
            <li className="nav-link">blog</li>
            <li className="nav-link">account</li>
            <li className="nav-link view-plans">view plans</li>
        </ul>
     );
}
 
export default NavLinks;